import axios from 'axios'
import toast from 'react-hot-toast';

const instance = axios.create({
   baseURL: process.env.REACT_APP_BASE_URL_NODE,
});

instance.interceptors.response.use(function (response) {
   console.log("response", response)
   return response;
}, function (error) {
   if (error.response && error.response.status == 401 && error.response.data.token == false) {
      // localStorage.removeItem('token')
      // window.location = "/login"
      toast.error("Login required to process.")
   }
   if (!error.response) {
      // localStorage.removeItem('token')
      // window.location = "/maintenance"
   }
   if (error?.response?.data?.msg == "Validation error") {
      toast.error(error?.response?.data.data);
      return Promise.reject(error);
   }
   if (error?.response?.data?.error == true) {
      toast.error(error?.response?.data?.msg);
      return Promise.reject(error);
   }
   return Promise.reject(error);
});

export default instance